module.exports = __webpack_public_path__ + "img/dialog1-btn-glod.8fae9539.png";